import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ImovelSimulationDTO } from '../dtos/imovel-simulation.dto';
import { VeiculoSimulationDTO } from '../dtos/veiculo-simulation.dto';
import { DuvidaDTO } from '../dtos/duvida.dto';

@Injectable({
    providedIn: 'root'
})
export class SimulationLP2ApiService {

    private readonly apiUrl = 'https://form-handler.tatikka.workers.dev/';

    constructor(private http: HttpClient) { }

    sendImovelSimulation2(data: ImovelSimulationDTO): Observable<any> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const payload = {
            ...data,
            formId: "porto-bank-consorcio_Simulacao-Imovel-LP2"
        };

        return this.http.post(this.apiUrl, payload, { headers }).pipe(
            tap(() => {
                this.trackSuccess('simulacao_imovel_lp2', 'Imovel');
            })
        );
    }

    sendVeiculoSimulation2(data: VeiculoSimulationDTO): Observable<any> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const payload = {
            ...data,
            formId: "porto-bank-consorcio_Simulacao-Veiculo-LP2"
        };

        return this.http.post(this.apiUrl, payload, { headers }).pipe(
            tap(() => {
                this.trackSuccess('simulacao_veiculo_lp2', 'Veiculo');
            })
        );
    }

    sendDuvida2(data: DuvidaDTO): Observable<any> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const payload = {
            ...data,
            formId: "porto-bank-consorcio_ContatoDuvida-LP2"
        };

        return this.http.post(this.apiUrl, payload, { headers }).pipe(
            tap(() => {
                this.trackSuccess('contato_duvida_lp2', 'Duvida');
            })
        );
    }

    private trackSuccess(eventName: string, category: string) {
        if (typeof window !== 'undefined') {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'form_submit_success',
                form_name: eventName,
                form_category: category
            });

            window.dataLayer.push({
                event: 'generate_lead',
                currency: 'BRL',
                value: 0
            });
        }
    }
}
